import { useState, useEffect, useCallback } from 'react';
import { getClaims } from '../../services/claimsService';
import type { Claim, ClaimActor } from '../../types/claims.types';

interface UseClaimsResult {
  isLoading: boolean;
  error: string | null;
  claims: Claim[];
  refresh: () => void;
}

export function useClaims(actor: ClaimActor | null, isAuthenticated: boolean): UseClaimsResult {
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const [claims, setClaims] = useState<Claim[]>([]);

  // Serialisér aktøren så effekten kun kører når den reelt ændrer sig.
  const actorKey = actor ? String(actor.employeeId) : '';

  const fetchClaims = useCallback(async () => {
    if (!actor || !isAuthenticated) return;
    setIsLoading(true);
    setError(null);
    try {
      setClaims(await getClaims());
    } catch (err) {
      setError(err instanceof Error ? err.message : 'Der opstod en fejl');
    } finally {
      setIsLoading(false);
    }
    // actorKey dækker actor-felterne; isAuthenticated styrer guard.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [actorKey, isAuthenticated]);

  useEffect(() => { fetchClaims(); }, [fetchClaims]);

  return { isLoading, error, claims, refresh: fetchClaims };
}
